export default __webpack_public_path__ + "static/media/toysoldierlarge.a7b5dcaa.png";